// extracted by mini-css-extract-plugin
module.exports = {"formDialogRoot":"EditProfileDialog_formDialogRoot__J7N1z","formDialogContent":"EditProfileDialog_formDialogContent__1WwF_"};